import { combineEpics } from 'redux-observable';
import { fetchTherapist$ } from './fetchTherapist$';
import { updateTherapist$ } from 'modules/therapist/epics/updateTherapist';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics(fetchTherapist$, updateTherapist$);
